exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".help-section{width:100%}.help-section h4,.help-section h5{color:#3f3f3f}.help-section svg{font-size:4rem}@media(max-width: 575px){.help-section svg{font-size:3.5rem}}.help-section ul{list-style-type:none;padding-left:0px}.help-section ul li{padding-top:.5em;color:#818181}.help-section ul li svg{margin:0;font-size:1.5rem}@media(max-width: 575px){.help-section ul li{font-size:.9rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/Appointment/HelpSection.scss
// module id = 7999
// module chunks = 13